import axios from "axios";
import ENV from "constants/env";

// Production builds sometimes set REACT_APP_BASE_URL without the /api suffix.
// All service paths use /companies/... under the API, so the host must end with /api.
const normalizeApiBaseUrl = (raw) => {
    if (!raw || typeof raw !== "string") return raw;
    const trimmed = raw.trim().replace(/\/+$/, "");
    if (!trimmed) return raw;
    if (trimmed.endsWith("/api")) return trimmed;
    return `${trimmed}/api`;
};

const axiosInstance = axios.create({
    baseURL: normalizeApiBaseUrl(ENV.BASE_URL),
    headers: {
        "X-API-key": ENV.API_KEY
    }
});

axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
    }
    const companyId = localStorage.getItem("companyId") || ENV.COMPANY_ID;
    if (companyId) {
        config.headers["X-Company-Id"] = companyId;
    }
    const locationId = localStorage.getItem("locationId");
    if (locationId) {
        config.headers["X-Location-Id"] = locationId;
    }
    return config;
});

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401) {
            localStorage.removeItem("authToken");
            localStorage.removeItem("userRole");
            localStorage.removeItem("companyId");
            localStorage.removeItem("employeeId");
            window.location.href = "/login";
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;